// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"search__msignaturepad___3bM8t","m-signature-pad--body":"search__m-signature-pad--body___5J5V3","m-signature-pad--footer":"search__m-signature-pad--footer___2D5SI","description":"search__description___zHLCb","button":"search__button___rpYyD","clear":"search__clear___3FXCW","save":"search__save___3hR1c","m-signature-pad":"search__m-signature-pad___3ouF1","github":"search__github___2PmPD","inputElement":"search__inputElement___1e8sL","submit":"search__submit___2dDs_","icon":"search__icon___24peq","wrapper":"search__wrapper___2UHP7"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/SearchBox/search.scss
// module id = yNA9
// module chunks = client